import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export default function WhitePaper() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Read The WhitePaper
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>WhitePaper</Modal.Title>
        </Modal.Header>
        <Modal.Body>
           <p><h5>PolygonRockers WhitePaper</h5></p>
           <p>Token Name:Rocks</p>
           <p>Token Ticker:$ROCK</p>
           <p>Total Supply:100,000,000,000</p>
           <p>Usage:Reward PolygonRocker Holders,Staking 
            PolygonRockers,Giveaways and Quickswap Liquidity for Trading</p>
            <p>Holder Allocation Amount:2400 $rock a daily 1000 on Mint</p>
            <p>Giveaway Allocation Amount:To be Announced</p>
            <p>Quickswap Liquidity:The rest</p>

            </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          
        </Modal.Footer>
      </Modal>
    </>
  );
}

